export const IconFreeSubs = (props) => {
  return (
    <svg
      viewBox="0 0 51 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" width="50" height="50" rx="10" fill="#F2F4F8" />
      <path
        d="M14 26C14 34.2843 20.7157 41 29 41C37.2843 41 44 34.2843 44 26C44 17.7157 37.2843 11 29 11"
        stroke="#302571"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M21.0621 14.5345C21.3843 13.6639 22.6157 13.6639 22.9379 14.5345L23.461 15.9482C23.5623 16.2219 23.7781 16.4377 24.0518 16.539L25.4655 17.0621C26.3361 17.3843 26.3361 18.6157 25.4655 18.9379L24.0518 19.461C23.7781 19.5623 23.5623 19.7781 23.461 20.0518L22.9379 21.4655C22.6157 22.3361 21.3843 22.3361 21.0621 21.4655L20.539 20.0518C20.4377 19.7781 20.2219 19.5623 19.9482 19.461L18.5345 18.9379C17.6639 18.6157 17.6639 17.3843 18.5345 17.0621L19.9482 16.539C20.2219 16.4377 20.4377 16.2219 20.539 15.9482L21.0621 14.5345Z"
        fill="#302571"
      />
      <path
        d="M11.0767 11.4951C11.3939 10.638 12.6061 10.638 12.9233 11.4951C13.023 11.7646 13.2354 11.977 13.5049 12.0767C14.362 12.3939 14.362 13.6061 13.5049 13.9233C13.2354 14.023 13.023 14.2354 12.9233 14.5049C12.6061 15.362 11.3939 15.362 11.0767 14.5049C10.977 14.2354 10.7646 14.023 10.4951 13.9233C9.63802 13.6061 9.63802 12.3939 10.4951 12.0767C10.7646 11.977 10.977 11.7646 11.0767 11.4951Z"
        fill="#302571"
      />
      <path
        d="M20.2095 31.1291L16.5939 32.7361C16.2327 32.8966 16.0171 33.2646 16.2246 33.6009C16.9661 34.8029 19.4081 36.8265 21.5 38.5C23.194 39.8552 26.2034 40.1104 28.0973 40.0555C28.6109 40.0406 29 39.6088 29 39.095V36.8431C29 36.6207 28.9259 36.4047 28.7894 36.2292L25.7284 32.2937C25.5811 32.1042 25.3705 31.9741 25.1352 31.927L20.8117 31.0623C20.6089 31.0218 20.3985 31.0451 20.2095 31.1291Z"
        fill="#302571"
        stroke="#302571"
        stroke-width="2"
      />
      <path
        d="M34.1998 34.5C33.576 35.4357 33.8032 36.9123 34.1189 38.1499C34.2887 38.8157 35.0849 39.0871 35.6204 38.6566C39.2119 35.7693 44.2071 30.0095 43.1488 23.1887C43.0769 22.7256 42.6665 22.4 42.1978 22.4H41.3662C41.0149 22.4 40.6894 22.2157 40.5087 21.9145L39.3296 19.9493C39.2133 19.7555 39.0348 19.6068 38.8232 19.5275L35.2629 18.1923C34.9434 18.0725 34.5848 18.1239 34.3118 18.3287L32.8557 19.4208C32.6588 19.5684 32.5233 19.7834 32.4751 20.0246L32.1149 21.8257C32.0439 22.1804 32.17 22.5457 32.4446 22.7811L35.5008 25.4007C35.7224 25.5907 35.85 25.868 35.85 26.1599V28.9289C35.85 28.9762 35.8469 29.0224 35.8399 29.0692C35.6459 30.3848 35.0643 33.2032 34.1998 34.5Z"
        fill="#302571"
        stroke="#302571"
        stroke-width="2"
      />
    </svg>
  );
};
